/* eslint-disable ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as ConversionUtils from '../../utils/conversion';

export default class BigHugeCircuit extends EmberObject {
  c1 = null;
  c2 = null;
  c5 = null;
  r1 = null;
  r2 = null;
  r3 = null;
  r4 = null;
  opAmpGbw = null;
  nominalGbw = null;
  nominalValues = null;
  realPartNormalizer = null;
  imaginaryPartNormalizer = null;

  @computed('realPart', 'imaginaryPart') get magnitude() {
    var realPart = this.realPart;
    var imaginaryPart = this.imaginaryPart;
    var result = Math.sqrt(realPart * realPart + imaginaryPart * imaginaryPart);
    return result;
  }

  @computed('realPart', 'imaginaryPart') get phase() {
    var realPart = this.realPart;
    var imaginaryPart = this.imaginaryPart;
    var result = Math.atan2(imaginaryPart, realPart);
    result = ConversionUtils.radianToDegree(result);
    return result;
  }

  @computed('nominalValues', 'circuitStageValues') get interimRealPart() {
    var circuitStageValues = this.circuitStageValues;
    var nominalValues = this.nominalValues;
    var nomGainQ = nominalValues.gain * nominalValues.stageQ;
    var result = circuitStageValues.gain * circuitStageValues.stageQ - nomGainQ;
    return result;
  }

  @computed('interimRealPart') get absoluteRealPart() {
    var interimRealPart = this.interimRealPart;
    var result = Math.abs(interimRealPart);
    return result;
  }

  @computed('nominalValues', 'circuitStageValues') get interimImaginaryPart() {
    var circuitStageValues = this.circuitStageValues;
    var nominalValues = this.nominalValues;
    var nominalFp = nominalValues.stageFp;
    var result = circuitStageValues.stageFp - nominalFp;
    return result;
  }

  @computed('interimImaginaryPart') get absoluteImaginaryPart() {
    var interimImaginaryPart = this.interimImaginaryPart;
    var result = Math.abs(interimImaginaryPart);
    return result;
  }

  @computed('interimRealPart', 'realPartNormalizer') get realPart() {
    var realPartNormalizer = this.realPartNormalizer;
    var result = this.interimRealPart;

    if (!!realPartNormalizer && realPartNormalizer > 0) {
      result = result / realPartNormalizer;
    }

    return result;
  }

  @computed('opAmpGbw', 'nominalGbw') get _imaginaryAdder() {
    var gbw = this.opAmpGbw;
    var nominalGbw = this.nominalGbw;
    var gbwDelta = gbw - nominalGbw;
    var result = 0;
    if (gbwDelta < 0) {
      result = -1e-6;
    } else if (gbwDelta > 0) {
      result = 1e-6;
    }

    return result;
  }

  @computed('interimImaginaryPart', 'imaginaryPartNormalizer', '_imaginaryAdder') get imaginaryPart() {
    var imaginaryPartNormalizer = this.imaginaryPartNormalizer;
    var _imaginaryAdder = this._imaginaryAdder;
    var result = this.interimImaginaryPart;

    if (!!imaginaryPartNormalizer && imaginaryPartNormalizer > 0) {
      result = result / imaginaryPartNormalizer + _imaginaryAdder;
    }

    return result;
  }
}
